<template>
    <div class="home-banner">
        <el-carousel :interval="6000" height="600px">
            <el-carousel-item v-for="(item,index) in list" :key="index">
                <img :src="`/api/v1/file/${item.image}`" class="banner-img" alt="">
            </el-carousel-item>
        </el-carousel>
        <div class="bottom-mask">
            <baidu-map class="map-content"
                       @ready="mapLoad"
                       center="东京"
                       :zoom="14"></baidu-map>
            <div class="input-content">
                <label class="el-icon-search" for="bannerSearch"></label>
                <input class="search-input" v-model="keyword" id="bannerSearch" placeholder="请输入地址搜索" type="text">
                <i v-if="showBtn" @click="getPosition" class="el-icon-location"></i>
                <el-date-picker
                        v-model="dateVal"
                        type="daterange"
                        range-separator="至"
                        class="mr-20"
                        start-placeholder="入住日期"
                        end-placeholder="退房日期">
                </el-date-picker>
                <div class="lines"></div>
                <div class="search-btn" @click="handlerSearch">搜索</div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapState} from 'vuex'

    export default {
        name: "HomeBanner",
        data(){
            return {
                list: [],
                dateVal: [],
                keyword: '',
                geolocation: '',
                showBtn: false
            }
        },
        mounted(){
            this.getBanner();
        },
        computed:{
            ...mapState(['userInfo'])
        },
        methods:{
            mapLoad({BMap, map}){
                this.showBtn = true;
                this.geolocation = new BMap.Geolocation();
            },
            async getBanner(){
                let [e, data]  = await this.$api.getHomeBannerApi()
                this.list = data.result;
            },
            handlerSearch(){
                if(!this.userInfo.detail){
                    return this.$eventBus.$emit('login')
                }
                if(!this.keyword){
                    return this.$message.warning('请输入地区')
                }
                this.$router.push({path: '/searchHouse', query:{key: this.keyword}})
            },
            getPosition(){
                this.geolocation.getCurrentPosition((res)=>{
                    this.keyword = res.address.city;
                })
            }
        }
    }
</script>

<style scoped lang="less">
    .home-banner{
        position: relative;
    }
    .banner-img{
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
    .bottom-mask{
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 140px;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: rgba(0,0,0,0.3);
        z-index: 2;
    }
    .input-content{
        width: 720px;
        height: 60px;
        border-radius: 6px;
        background-color: #ffffff;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        padding: 0 30px;
        box-sizing: border-box;
        .el-icon-search{
            margin-right: 10px;
            font-size: 28px;
            color: #949494;
        }
        .el-icon-location{
            margin: 0 10px;
            font-size: 28px;
            color: #e44646;
        }
        .search-input{
            border: none;
            outline: none;
            width: 280px;
            height: 30px;
            line-height: 30px;
            font-size: 16px;
            color: #949494;
        }
        .lines{
            width: 1px;
            height: 30px;
            background-color: #949494;
        }
        .search-btn{
            width: 160px;
            margin: 0 auto;
            height: 40px;
            line-height: 40px;
            border-radius: 6px;
            background-color: #e44646;
            text-align: center;
            color: #ffffff;
            cursor: pointer;
            &:hover{
                background-color: #c62b26;
            }
        }
    }
</style>
